<template>
    <div class="card p-shadow-app">
        <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
        <Loading :active.sync="loading" :isFullPage="true"></Loading>
        <div class="card p-shadow-app">
            <header class="jumbotron">
                <h3>Integração LG - Configurações Códigos</h3>
            </header>
            <div class="p-col-12 p-md-12">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <LgTableConfigCodes code="symptom" v-model="form.symptom" :saving="loading" @save="save" />
                    </div>

                    <div class="p-field p-col-12 p-md-6">
                        <LgTableConfigCodes code="symptom2" v-model="form.symptom2" :saving="loading" @save="save" />
                    </div>
                </div>

                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <LgTableConfigCodes code="defect" v-model="form.defect" :saving="loading" @save="save" />
                    </div>

                    <div class="p-field p-col-12 p-md-6">
                        <LgTableConfigCodes code="primary_repair_code" v-model="form.primary_repair_code" :saving="loading" @save="save" />
                    </div>
                </div>

                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <LgTableConfigCodes code="repair_level_code" v-model="form.repair_level_code" :saving="loading" @save="save" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import LgTableConfigCodes from '@/components/LgConfigurations/LgTableConfigCodes.vue';
import lgService from '@/services/lg.service';

export default {
    name: "IntegrationLgConfigCodesForm",
    components: {
        LgTableConfigCodes,
    },
    data() {
        return {
            loading: false,
            form: {
                symptom: [],
                symptom2: [],
                defect: [],
                primary_repair_code: [],
                repair_level_code: []
            }
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            this.loading = true;
            try {
                const groupedCodes = await lgService.getGroupedConfigCodes();

                this.form.symptom = groupedCodes.symptom || [];
                this.form.symptom2 = groupedCodes.symptom2 || [];
                this.form.defect = groupedCodes.defect || [];
                this.form.primary_repair_code = groupedCodes.primary_repair_code || [];
                this.form.repair_level_code = groupedCodes.repair_level_code || [];
            } finally {
                this.loading = false;
            }
        },
        async save() {
            this.loading = true;
            try {
                let codes = [];

                Object.keys(this.form).forEach(key => {
                    this.form[key].forEach(item => {
                        codes.push({
                            id: item.id || null,
                            type_code: key,
                            code: item.code,
                            description: item.description
                        });
                    });
                });

                await lgService.updateConfigCodes({ codes });

                this.$toast.add({severity:'success', summary: 'Sucesso', detail:'Configuração registada', life: 3000});
            } catch (error) {
                this.$toast.add({severity:'error', summary: 'Erro', detail:'Falha ao guardar configuração', life: 3000});
            } finally {
                this.loading = false;
            }
        }
    }
};

</script>